import { render } from "./DynamicChip.vue?vue&type=template&id=85627cf6"
import script from "./DynamicChip.vue?vue&type=script&lang=js"
export * from "./DynamicChip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__